export const accountComponents = {
  // OtaLinksBar.vue — شريط روابط الـ OTA
  otaLinks: {
    copied: "تم النسخ!",
    copy: "نسخ",
    edit: "تعديل",
    remove: "إزالة",
    addLink: "رابط OTA",
    modalEyebrow: "رابط الإعلان في الـ OTA",
    modalEyebrowUnit: "رابط هذه الوحدة في موقع الحجز",
    editTitle: "تعديل الرابط",
    addTitle: "إضافة رابط OTA",
    modalHint: "الصق الرابط العام لـ <b>هذا الإعلان</b> في الـ OTA. يتيح لك نسخه وفتحه بسرعة.",
    urlLabel: "رابط الإعلان",
    cancel: "إلغاء",
    saving: "جارٍ الحفظ…",
    save: "حفظ الرابط",
    saveError: "تعذّر حفظ الرابط. تحقق من الرابط.",
    fromListing: "من الإعلان",
    inheritedNote: "هذا رابط الإعلان. وما لم يكن لهذه الوحدة رابط خاص بها، فهو الرابط الذي نرسله.",
    override: "تعيين رابط خاص",
    modalHintUnit: "الصق الرابط العام <b>لهذه الوحدة</b> في موقع الحجز. إذا حددته فسيُرسل هذا الرابط؛ وإذا تركته فارغًا فسيُرسل رابط الإعلان.",
  },

  // GuestJourneySimulator.vue — محاكي رحلة الضيف
  journeySim: {
    title: "محاكاة رحلة الضيف",
    badge: "اختبار",
    intro: "أعد تشغيل العملية بأكملها —من الحجز حتى التقييم— في محادثة واتساب. أدخل اسمًا ورقمًا واضغط <strong>تشغيل</strong>. إذا فعّلت «الإرسال إلى الجوال»، تُرسَل كل رسالة فعليًا إلى الرقم لتجربته والتحدث مع وكيل الذكاء الاصطناعي.",
    guestNameLabel: "اسم الضيف",
    guestNamePlaceholder: "مثال: Laura García",
    phoneLabel: "رقم واتساب (للاختبار)",
    phoneHint: "الصيغة الدولية، مثال: +34 600123456",
    toggleTitle: "الإرسال إلى الجوال أيضًا",
    toggleDesc: "تُرسَل كل مرحلة فعليًا إلى الرقم أعلاه",
    warn: "أرسل أولًا «مرحبًا» إلى الرقم من جوالك لفتح نافذة الـ 24 ساعة في واتساب؛ بهذا ستستقبل الرسائل فورًا.",
    reset: "إعادة التشغيل",
    prev: "السابق",
    pause: "إيقاف مؤقت",
    play: "تشغيل",
    continue: "متابعة",
    next: "التالي",
    stepProgress: "الخطوة {current} من {total}",
    guestFallback: "ضيف",
    propertyFallback: "مكان إقامتك",
    testNumberFallback: "رقم تجريبي",
    dayLabel: "رحلة الضيف",
    loadingMsgs: "جارٍ تحميل رسائلك…",
    pressPlay: "اضغط <strong>تشغيل</strong> لبدء الرحلة ▶",
    hintSending: "الإرسال الفعلي مُفعّل · تصل كل خطوة إلى {phone}",
    hintSimulated: "عرض محاكاة · فعّل «الإرسال إلى الجوال» للتجربة على هاتف حقيقي",
    toastInvalidPhone: "أدخل رقم واتساب صالحًا للإرسال إلى الجوال.",
    toastSendFailed: "تعذّر الإرسال.",
    toastSendMobileFailed: "تعذّر الإرسال إلى الجوال.",
    // رسائل واتساب المُحاكاة (تُحلّ الرموز {{...}} عبر resolve())
    msgConfirmation: "مرحبًا *{{nombre_huesped}}* 👋\n\nتم تأكيد حجزك في *{{nombre_alojamiento}}* ✅\n\nرمز الحجز: *6233Q1VC5*\nالتواريخ: *{{fecha_entrada}}* – *{{fecha_salida}}* 📅\n\nعبر واتساب هذا يمكنك طلب رابط تسجيل الوصول عبر الإنترنت واستلام تعليمات الوصول.",
    msgCheckinPrompt: "*مرحبًا* 👋 أنا المساعد الافتراضي لـ *{{nombre_alojamiento}}*.\n\nاضغط *Ok* لمتابعة تسجيل وصولك.",
    msgChooseLanguage: "Elige tu idioma · Choose your language",
    msgCheckinLink: "*شكرًا* 👋 هذا رابطك لإتمام تسجيل الوصول 😎\n\nhttps://guest.wacheckin.com/checkin/6233Q1VC5",
    msgWelcome: "👋 أهلًا بك في *{{nombre_alojamiento}}*، {{nombre_huesped}}!\n\nشكرًا لإكمال تسجيلك. إليك كل المعلومات عن إقامتك.",
    msgAccess: "🔒🔑 *رمز الدخول · {{nombre_alojamiento}}*\n\nرمزك هو: *58117*\n\nصالح طوال فترة إقامتك.",
    msgArrival: "🏡 *تعليمات الوصول*\n\nعند الوصول، توجّه إلى المدخل الرئيسي وأدخل رمزك في القفل. 🔑\n\nإقامة سعيدة! ✨",
    msgGuestCheckout: "مرحبًا، متى موعد تسجيل المغادرة؟",
    msgCheckoutReply: "مرحبًا! تسجيل المغادرة حتى الساعة *12:00* 🕚 إذا احتجت المغادرة لاحقًا، يمكنني البحث لك عن مغادرة متأخرة 😊",
    msgCheckout: "مرحبًا *{{nombre_huesped}}* 👋\n\nنذكّرك بأن *إقامتك تنتهي غدًا* في *{{nombre_alojamiento}}*.\n\n🕚 أقصى موعد للمغادرة هو الساعة *{{hora_salida}}*.\n\nشكرًا جزيلًا على زيارتك ورحلة سعيدة! 😊",
    msgReview: "⭐ كيف كانت إقامتك في *{{nombre_alojamiento}}*، {{nombre_huesped}}؟\n\nيسعدنا معرفة رأيك. اترك لنا تقييمك هنا 👉 https://g.page/r/review",
  },

  // GuestJourneyTimeline.vue — الخط الزمني لرحلة الضيف
  journeyTimeline: {
    title: "رحلة الضيف",
    subtitle: "من الحجز حتى المغادرة. مرّر المؤشر فوق كل حدث لرؤية الرسالة.",
    disabled: "معطّل",
    clickToConfigure: "انقر للإعداد",
    nameFallback: "مكان إقامتك",
    // تسميات العُقد
    labelLead: "حجز / عميل محتمل",
    labelConfirm: "التأكيد",
    labelCheckinLink: "رابط تسجيل الوصول",
    labelWelcome: "الترحيب",
    labelAccess: "الدخول / القفل",
    labelArrival: "تعليمات الوصول",
    labelCheckout: "رسالة المغادرة",
    labelReview: "التقييم",
    // توقيت كل عُقدة
    whenLead: "عند الحجز أو المراسلة",
    whenConfirm: "تم تأكيد الحجز",
    whenCheckinLink: "قبل الوصول",
    whenWelcome: "بعد التسجيل",
    whenAccess: "يوم الوصول",
    whenArrival: "يوم الوصول",
    whenCheckout: "عشية المغادرة",
    whenReview: "بعد المغادرة",
    // معاينات واتساب
    previewLead: "👋 مرحبًا! أنا المساعد الافتراضي لـ *{name}*.\n\nأنا هنا لمساعدتك في حجزك والإجابة عن أي استفسار.",
    previewConfirm: "مرحبًا *Laura García* 👋\n\nتم تأكيد حجزك في *{name}* ✅\n\nرمز الحجز: *6233Q1VC5*\nالتواريخ: *05/06/2026* – *07/06/2026* 📅\n\nعبر واتساب هذا يمكنك طلب رابط تسجيل الوصول عبر الإنترنت، وكذلك استلام تعليمات الوصول.\nإذا احتجت المساعدة قبل إقامتك أو خلالها، راسلنا هنا 💬",
    previewWelcome: "👋 أهلًا بك في *{name}*!\n\nشكرًا لإكمال تسجيلك. إليك كل المعلومات عن إقامتك.",
    previewAccess: "🔒🔑 *رمز الدخول · {name}*\n\nرمزك هو: *58117*\n\nصالح طوال فترة إقامتك.",
    previewArrival: "🏡 *تعليمات الوصول*\n\nعند الوصول، توجّه إلى المدخل الرئيسي لمكان الإقامة. 🔑\n\nإقامة سعيدة! ✨",
    previewCheckout: "مرحبًا 👋\n\nنذكّرك بأن *إقامتك تنتهي غدًا* في *{name}*.\n\n🕚 أقصى موعد للمغادرة هو الساعة *12:00*.\n\nرحلة سعيدة! 😊",
    previewReview: "⭐ كيف كانت إقامتك في *{name}*؟\n\nيسعدنا معرفة رأيك. اترك لنا تقييمك هنا 👉 …",
    previewLeadNoWaba: "📲 *فعّل وكيل الذكاء الاصطناعي* للتعامل مع الحجوزات الجديدة عبر واتساب بربط رقمك الخاص.\n\nبهذا سيردّ المساعد على الأشخاص الذين ليسوا عملاء بعد، مجيبًا عن الاستفسارات حول أماكن الإقامة وموجّهًا إياهم نحو الحجز.",
    // محادثة "رابط تسجيل الوصول" الكاملة
    chatCheckinAgent1: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{name}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
    chatChooseLanguage: "Elige tu idioma · Choose your language",
    chatCheckinLink: "*شكرًا* 👋 هذا رابطك لإتمام تسجيل الوصول. 😎\n\nhttps://guest.wacheckin.com/…",
    // رسائل الدخول (الأقفال)
    lockLabelFallback: "المدخل",
    lockDynamic: "🔒🔑 *{label} · {name}*\n\nرمز دخولك هو: *58117*\n\nصالح طوال فترة إقامتك.",
    lockNone: "🔑 *{label} · {name}*\n\nصندوق المفاتيح يُفتح بالرمز: *{code}*\n\nستجد بداخله مفاتيح مكان الإقامة.",
    lockDefault: "🔒🔑 *{label} · {name}*\n\nرمز القفل هو: *{code}*\n\nاستخدمه لفتح الباب.",
    // رسالة المغادرة (احتياطية)
    checkoutFallback: "مرحبًا، *María* 👋\n\nنذكّرك بأن إقامتك تنتهي غدًا في *{name}*.\n\n🕚 أقصى موعد للمغادرة هو الساعة *{time}*.\n\nشكرًا جزيلًا على إقامتك. رحلة سعيدة! 😊",
  },

  // ListingIcalPanel.vue — لوحة مزامنة iCal
  icalPanel: {
    eyebrow: "تقويم iCal",
    heading: "مزامنة iCal",
    pageDesc: "صدّر حجوزاتك إلى منصات أخرى واستورد تقويمات خارجية لحجب التواريخ تلقائيًا في إعلانك.",
    loading: "جارٍ تحميل الإعداد…",
    exportLabel: "رابط iCal الخاص بك (تصدير)",
    exportDesc: "انسخ هذا الرابط والصقه في Airbnb أو Booking.com أو أي منصة تدعم المزامنة عبر iCal. ستسحب حجوزاتك تلقائيًا.",
    copied: "تم النسخ",
    copy: "نسخ",
    tipAllUnits: "يشمل هذا الرابط حجوزات <strong>جميع وحدات</strong> الإعلان.",
    tipHotelRooms: "لكل <strong>غرفة فعلية</strong> رابطها الخاص. اربطه في Airbnb/Booking لتلك الغرفة تحديدًا، وسيتم تصدير حجوزات تلك الغرفة فقط.",
    importLabel: "التقويمات الخارجية (استيراد)",
    syncing: "جارٍ المزامنة…",
    syncAll: "مزامنة الكل",
    importDesc: "الصق روابط iCal من منصاتك الأخرى (Airbnb، Booking.com، إلخ) وسيحجب Wacheckin تلك التواريخ تلقائيًا في تقويمك.",
    lastSync: "آخر مزامنة: {date}",
    delete: "حذف",
    empty: "ليست لديك أي تقويمات خارجية مرتبطة بعد.",
    addExternal: "إضافة تقويم خارجي",
    newExternal: "تقويم خارجي جديد",
    nameLabel: "اسم التقويم",
    namePlaceholder: "مثال: Airbnb - شقة 1",
    physicalRoom: "غرفة فعلية",
    listingUnit: "وحدة الإعلان",
    selectRoomPlaceholder: "اختر غرفة…",
    selectUnitPlaceholder: "اختر وحدة…",
    urlLabel: "رابط تقويم iCal",
    cancel: "إلغاء",
    saving: "جارٍ الحفظ…",
    saveSync: "حفظ ومزامنة",
    defaultGroup: "الغرف",
    toastLoadError: "تعذّر تحميل إعداد iCal.",
    toastSelectUnit: "اختر غرفة / وحدة.",
    toastAdded: "تمت إضافة التقويم ومزامنته بنجاح.",
    toastAddError: "خطأ في إضافة التقويم.",
    deleteConfirm: 'حذف "{name}" وجميع حجوزاته المحجوبة؟',
    toastDeleted: "تم حذف التقويم.",
    toastDeleteError: "تعذّر حذف التقويم.",
    toastSyncError: "خطأ في المزامنة.",
  },

  // ListingIcalModal.vue — نافذة مزامنة iCal
  icalModal: {
    title: "مزامنة iCal",
    loading: "جارٍ تحميل الإعداد…",
    exportLabel: "رابط iCal الخاص بك (تصدير)",
    exportDesc: "انسخ هذا الرابط والصقه في Airbnb أو Booking.com أو أي منصة تدعم المزامنة عبر iCal. ستسحب حجوزاتك تلقائيًا.",
    copied: "تم النسخ",
    copy: "نسخ",
    tipAllUnits: "يشمل هذا الرابط حجوزات <strong>جميع وحدات</strong> الإعلان.",
    tipHotelRooms: "لكل <strong>غرفة فعلية</strong> رابطها الخاص. اربطه في Airbnb/Booking لتلك الغرفة تحديدًا، وسيتم تصدير حجوزات تلك الغرفة فقط.",
    importLabel: "التقويمات الخارجية (استيراد)",
    syncing: "جارٍ المزامنة…",
    syncAll: "مزامنة الكل",
    importDesc: "الصق روابط iCal من منصاتك الأخرى (Airbnb، Booking.com، إلخ) وسيحجب Wacheckin تلك التواريخ تلقائيًا في تقويمك.",
    lastSync: "آخر مزامنة: {date}",
    delete: "حذف",
    empty: "ليست لديك أي تقويمات خارجية مرتبطة بعد.",
    addExternal: "إضافة تقويم خارجي",
    newExternal: "تقويم خارجي جديد",
    nameLabel: "اسم التقويم",
    namePlaceholder: "مثال: Airbnb - شقة 1",
    physicalRoom: "غرفة فعلية",
    listingUnit: "وحدة الإعلان",
    selectRoomPlaceholder: "اختر غرفة…",
    selectUnitPlaceholder: "اختر وحدة…",
    urlLabel: "رابط تقويم iCal",
    cancel: "إلغاء",
    saveSync: "حفظ ومزامنة",
    defaultGroup: "الغرف",
    toastLoadError: "تعذّر تحميل إعداد iCal.",
    toastSelectUnit: "اختر غرفة / وحدة.",
    toastAdded: "تمت إضافة التقويم ومزامنته بنجاح.",
    toastAddError: "خطأ في إضافة التقويم.",
    deleteConfirm: 'حذف "{name}" وجميع حجوزاته المحجوبة؟',
    toastDeleted: "تم حذف التقويم.",
    toastDeleteError: "تعذّر حذف التقويم.",
    toastSyncError: "خطأ في المزامنة.",
  },
};
